import * as type from '../types/penTypes'

const initialState = {
    saved : false,
    pen_html : ``,
    pen_css :  ``,
    pen_js : ``,
    pen_title : 'untitled',
    pen_description : '',
    pen_id : null,
    pen_user_id : null,
    pen_user_name : '',
    user_photo_url : '',
    jsSettings: {
        jsCdnList: []
    },
    cssSettings: {
        cssCdnList: []
    },
    htmlSettings: {
        htmlClassTag: '',
        head: ''
    },
    loves : [],
    forks : [],
    views : 0,
    love_count : 0,
    fork_count : 0,
    pen_type : "created"
}
const penReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.SET_EDITOR_MODE:
            return {
                ...state,
                pen_mode : action.payload
            };
        case type.SET_PEN_HTML:
            return {
                ...state,
                pen_html : action.payload
            };
        case type.SET_PEN_CSS:
            return {
                ...state,
                pen_css : action.payload
            };        
        case type.SET_PEN_JS:
            return {
                ...state,
                pen_js : action.payload
            };
        case type.SET_PEN_TITLE : 
            return {
                ...state,
                pen_title : action.payload
            };
        case type.SET_PEN_DESCRIPTION:
            return {
                ...state,
                pen_description : action.payload
            }; 

        case type.ADD_CSS_CDN : 
            return {
                ...state,
                cssSettings : {
                    cssCdnList : [...state.cssSettings.cssCdnList, action.payload]
                }
            }
        case type.REMOVE_CSS_CDN : 
            return {
                ...state,
                cssSettings : {
                    cssCdnList : state.cssSettings.cssCdnList.filter(e => !e.startsWith(action.payload))
                }
            }
        case type.ADD_JS_CDN : 
            return {
                ...state,
                cssSettings : {
                    cssCdnList : [...state.jsSettings.jsCdnList, action.payload]
                }
            }
        case type.REMOVE_JS_CDN : 
            return {
                ...state,
                cssSettings : {
                    cssCdnList : state.jsSettings.jsCdnList.filter(e => !e.startsWith(e))
                }
            }
        case type.SET_CLASS_TAG : 
        return {
            ...state,
            htmlSettings : {
                head : state.htmlSettings.head,
                htmlClassTag : action.payload
            }
        }
        case type.SET_HEAD_STUFF : 
        return {
            ...state,
            htmlSettings : {
                head : action.payload,
                htmlClassTag : state.htmlSettings.htmlClassTag
            }
        }
        case type.LOAD_PEN:
            return {
                ...state,
                ...action.payload
            }
        case type.SET_DEFAULT_PEN:
            return {
                ...state,
                ...action.payload
            }
        default:
            return {...state};
    }
};

export default penReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/penReducer.js